import EtablissementUrssaf from '@/generated/controls/etablissement/EtablissementUrssaf.vue';
import Caisse from '@/extend/classes/Caisse';
import validator, { rules, RULES_FRENCH_LABEL } from '@/generated/validators/ValidationRules';
import { defineComponent } from "vue";

export let codesUrssaf: string[] = [];

export function isValidUrssafEmployeur(value: string): boolean {
    if (value.length >= 3) {
        return codesUrssaf.find(a => a == value.substring(0, 3)) != undefined
    } else {
        return false;
    }
}

export default defineComponent({
    components: {},
    extends: EtablissementUrssaf,
    data() {
        return {
            codesUrssaf
        };
    },
    mounted() {
        Caisse.listUrssaf().then((res: string[]) => {
            codesUrssaf = res;
        })
    },
    methods: {

        focusValidator(value: string): validator | null {
            const rule = rules.urssafValid;
            rule.function = isValidUrssafEmployeur;
            return new validator(rule, 'Numéro de caisse invalide');
            return null;
        }
    }
})
